module.exports = __webpack_public_path__ + "img/operate_list6.91fa096a.png";